const store = {
    namespaced: true,
    state() {
        return {
            promotions: [],
            products: [],
            promo: {}
        }
    },
    getters: {
        getPromotions(state) {
            return state.promotions
        },
        getPromo(state) {
            return state.promo
        },
        getProducts(state) {
            return state.products
        }
    },
    mutations: {
        setProducts(state, products) {
            state.products = products
        },
        addProducts(state, products) {
            state.products = state.products.concat(products)
        },
        setPromotions(state, promotions) {
            state.promotions = promotions
        },
        setPromo(state, promo) {
            state.promo = promo
        }
    },
}

export default store